import React from "react";
import { Link } from "react-router-dom";
import { useLocale } from "../context/LocaleContext";
import { useShop } from "../context/ShopContext";
import ParticleHero from "../components/ParticleHero";
import Seo from "../components/Seo";

const seoData = {
  it: {
    title: "Home",
    description:
      "IdeaMedia agenzia web: comunicazione, marketing, sviluppo siti web, software e moduli custom. Le tue idee online.",
  },
  en: {
    title: "Home",
    description:
      "IdeaMedia web agency: communication, marketing, website development, custom software and modules. Your ideas online.",
  },
};

const Home = () => {
  const { t, lang } = useShop();
  const { lp } = useLocale();

  return (
    <div data-testid="home-page">
      <Seo title={seoData[lang].title} description={seoData[lang].description} />

      {/* Fullscreen hero - Bridge particle slider style with background photo */}
      <section
        className="idm-hero idm-hero-photo idm-hero-full"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL || ""}/images/hero-bg.jpg)`,
        }}
      >
        <ParticleHero />
        <div className="idm-hero-content">
          <h1 className="idm-hero-title">{t("heroTitle")}</h1>
          <p className="idm-hero-subtitle">{t("heroSubtitle")}</p>
          <Link to={lp("/contatti")} className="idm-btn-yellow" data-testid="hero-cta">
            {t("heroCta")}
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
